import { apiFetch } from "./client";

export const fetchWishlistIds = () =>
  apiFetch("/enduser/wishlist/", {
    credentials: "include",
  });

export const fetchWishlistProducts = () =>
  apiFetch("/enduser/wishlist/products/", {
    credentials: "include",
  });

export const toggleWishlist = (productId) =>
  apiFetch("/enduser/wishlist/toggle/", {
    method: "POST",
    credentials: "include",
    body: JSON.stringify({ product_id: productId }),
  });
